<template lang="pug">
#app(:class='{ background: ["home"].includes($route.name) }')
    .zhezhao(v-if='active', @click='active = false')
    a(
        href="https://webchat.7moor.com/wapchat.html?accessId=33c94e80-c8ec-11eb-9d18-d7e532a7d40e&fromUrl=&urlTitle=&language=ZHCN"
        v-if='["introduce", "introduceDetail", "introduceDetail2", "about"].includes($route.name)'
    )
        img.contact(src='https://oss.cloud.custouch.com/res/35729/在线客服浮窗@3x.png')
    .nav(:class='{ nav2: $route.name == "home" }')
        img.logo(
            src='@/assets/imgs/logo@3x.png',
            @click='$router.push("/home")'
        )
        .bar-container(:class='{ "bar-container2": $route.name == "home" }')
            img(src="https://oss.cloud.custouch.com/res/46110/wecom-temp-65d8c61071ee6271a46a94a4eab7e725.png" v-show="'collection,binding,record,gift,address,addressAdd,addressEdit'.includes($route.name)" @click="$router.push('/my')")
            img.bar(src='@/assets/imgs/nav@3x.png', @click='active = true')
        .position(v-if='active')
            .item(v-for='(item, index) in list', @click='push(item.push)')
                .img-container
                    img(:src='require(`@/assets/imgs/${item.img}`)')
                .text {{ item.title }}
    .bread(v-if='!["home"].includes($route.name)')
        .img-container(@click='$router.push("/home")')
            img.home(src='@/assets/imgs/home@3x.png')
            .wenzi 首页
            img.arrow(src='@/assets/imgs/arrow@3x.png')
        .bread-item(
            v-for='(item, index) in data',
            :key='index',
            :class='{ none: index == 1 || index == 0, width: index == 2 }'
        )
            .wenzi(
                :class='{ active1: index == 0 && data.length == 1, active2: index == data.length - 1 && data.length > 1, ellipsis: index == 2 }',
                @click='jump(item, index)'
            ) {{ item.title }}
            img.arrow(
                src='@/assets/imgs/arrow@3x.png',
                v-if='index + 1 != data.length'
            ) 
    transition(name='fade', mode='out-in')
        router-view.sr
</template>

<script>
import {
    setBaseInfo,
    initSet,
    updateWxShareData,
    concatWithDashLine,
} from '@/configs/common'
import { mapActions, mapState } from 'vuex'
import { NLY_PID_STR } from './views/levelTitle'
export default {
    name: 'app',
    data() {
        return {
            active: false,
            data: [],
            list: [
                {
                    title: '个人中心',
                    img: '个人中心.png',
                    push: '/my',
                },
                {
                    title: '百宝箱',
                    img: 'icon-box.png',
                    push: '/utils',
                },
                {
                    title: '市场应用及案例',
                    img: '市场应用.png',
                    push: '/market',
                },
                {
                    title: '产品介绍',
                    img: '产品介绍.png',
                    push: '/introduce',
                },
                {
                    title: '资料下载',
                    img: '资料下载.png',
                    push: '/download',
                },
                {
                    title: '直播看点',
                    img: '材料课堂.png',
                    push: '/class',
                },
                {
                    title: '关于我们',
                    img: '关于我们.png',
                    push: '/about',
                },
            ],
        }
    },
    computed: {
        cmsStr(){
            const { poolId } = window.env.VITE_DATA
            const { params, query, meta } = this.$route
            const cmsGroup = [
                poolId,
                params.mId || query.mId || meta.mId,
                params.hId || query.hId || meta.hId,
                params.rId || query.rId
            ]
            const cmsJ = cmsGroup.join(',')
            return NLY_PID_STR === cmsJ ? undefined : cmsJ
        },
        pageInfo() {
            return {
                title: this.$route.meta.title,
                cms: this.cmsStr,
                shareInfo: {
                    title: this.$route.meta.title + '-' + document.title,
                    description: '点击查看详情',
                    image: window.env.VUE_APP_LOGO,
                },
            }
        },
    },
    methods: {
        jump(item, index) {
            if (index + 1 == this.data.length) {
                return
            } else {
                this.$router.push({ name: item.name, params: item.params })
            }
        },
        push(push) {
            this.active = false
            this.$router.push({ path: push })
        },
        ...mapActions(['setInfo']),
        initWatch() {
            this.$watch(
                'pageInfo',
                (nv, ov) => {
                    // 初始化签名
                    const { noTrack, title, reInit } = this.$route.meta
                    if (!this.hasInited || reInit) {
                        this.hasInited = true
                        initSet(nv)
                    } else {
                        // 更新追踪
                        if (nv.title !== ov.title && !noTrack && title) {
                            setBaseInfo(nv)
                        }
                    }
                },
                { immediate: true }
            )
        },
    },
    async created() {
        this.setInfo()
        this.initWatch()
        // 页面追踪
        this.$root.$on('pageview', (params) => {
            setBaseInfo(Object.assign({}, this.pageInfo, params))
        })
        this.$root.$on('updateShare', (params) => {
            updateWxShareData(
                Object.assign({}, this.pageInfo.shareInfo, params)
            )
        })
        this.$root.$on('sign', () => {
            const signIn = {
                title: this.pageInfo.title,
                remark: '每日签到',
                path: window.location.href,
                uaId: window.ca('get', 'tid'),
            }
            window.cw('action', 'signInview', signIn)
        })
        this.$root.$on('action', (params) => {
            switch (params.name) {
                case 'market':
                    this.data = [{ title: '市场应用及案例' }]
                    break
                case 'marketDetail':
                    this.data = [
                        { title: '市场应用及案例', name: 'market' },
                        { title: params.marketName },
                    ]
                    break
                case 'marketDetail2':
                    this.data = [
                        { title: '市场应用及案例', name: 'market' },
                        {
                            title: params.marketName,
                            name: 'marketDetail',
                            params: { marketId: params.marketNameId },
                        },
                        { title: params.childMarketName },
                    ]
                    break
                case 'introduce':
                    this.data = [{ title: '产品介绍' }]
                    break
                case 'contact':
                    this.data = [{ title: '联系我们' }]
                    break
                case 'introduceDetail':
                    this.data = [
                        { title: '产品介绍', name: 'introduce' },
                        { title: params.introduceName },
                    ]
                    break
                case 'introduceDetail2':
                    this.data = [
                        { title: '产品介绍', name: 'introduce' },
                        {
                            title: params.introduceName,
                            name: 'introduceDetail',
                            params: { introduceName: params.introduceName },
                        },
                        { title: params.introduceName2 },
                    ]
                    break
                case 'my':
                    this.data = [{ title: '个人中心' }]
                    break
                case 'binding':
                    this.data = [{ title: '个人中心', name: 'my' }, { title: '1688绑定' }]
                    break
                case 'record':
                    this.data = [{ title: '个人中心', name: 'my' }, { title: '积分记录' }]
                    break
                case 'gift':
                    this.data = [{ title: '个人中心', name: 'my' }, { title: '积分兑换' }]
                    break
                case 'utils':
                    this.data = [{ title: '个人中心', name: 'my' }, { title: '百宝箱' }]
                    break
                case 'collection':
                    this.data = [{ title: '个人中心', name: 'my' }, { title: '我的收藏' }]
                    break
                case 'address':
                    this.data = [{ title: '个人中心', name: 'my' }, { title: '收货地址' }]
                    break
                case 'addressAdd':
                    this.data = [{ title: '个人中心', name: 'my' }, { title: '收货地址' }]
                    break
                case 'download':
                    this.data = [{ title: '资料下载' }]
                    break
                case 'about':
                    this.data = [{ title: '关于我们' }]
                    break
                case 'class':
                    this.data = [{ title: '直播看点' }]
                    break
                case 'pdfView':
                    this.data = [
                        { title: '资料下载', name: 'download' },
                        { title: params.a },
                    ]
                    break
            }
        })
    },
}
</script>
<style lang="less" scoped>
@import "~@/assets/style/mixin.less";
.width {
    width: 4rem;
}
.contact {
    z-index: 999999;
    width: 3rem;
    position: absolute;
    right: -0.3rem;
    bottom: 6%;
    object-fit: contain;
}
.active1 {
    color: #222222 !important;
    text-decoration: none !important;
}
.active2 {
    color: #222222 !important;
    text-decoration: none !important;
}
.arrow {
    height: 0.5rem !important;
}
.zhezhao {
    width: 100%;
    height: 100%;
    background-color: transparent;
    position: fixed;
    z-index: 9999;
}

.bread {
    margin-top: 0.45rem;
    height: 0.85rem;
    display: flex;
    margin-left: 1rem;
    margin-bottom: 0.9rem;
    .bread-item {
        display: flex;
        align-items: center;
        flex: 1;
        .wenzi {
            font-size: 0.6rem;
            color: #219cdc;
            text-decoration: underline;
            line-height: 0.6rem;
            margin-right: 0.25rem;
            margin-left: 0.25rem;
            white-space: nowrap;
        }
        .arrow {
            height: 0.8rem;
        }
    }
    .img-container {
        display: flex;
        align-items: center;
        height: 0.85rem;

        .home {
            height: 0.75rem;
            position: relative;
            top: -0.05rem;
        }
        .wenzi {
            font-size: 0.6rem;
            color: #0097d6;
            line-height: 0.6rem;
            margin-right: 0.25rem;
            white-space: nowrap;
            flex-wrap: nowrap;
        }
    }
}
.background {
    background-image: url("https://oss.cloud.custouch.com/res/21687/bg.png");
    background-size: cover;
}
#app {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    .none {
        flex: none;
    }
}
.nav2 {
    height: 3rem !important;
    padding-right: 0.8rem !important;
}
.nav {
    width: 100%;
    height: 2.5rem;
    position: relative;
    display: flex;
    padding-left: 0.5rem;
    padding-right: 1rem;
    justify-content: space-between;
    .logo {
        height: 100%;
        object-fit: cover;
    }
    .bar-container2 {
        padding-top: 1.2rem !important;
        padding-bottom: 1.1rem !important;
    }
    .bar-container {
        display: flex;
        align-items: center;
        color: #219cdc;
        img,
        .bar {
            width: 1rem;
            height: auto;
        }
        .bar {
            margin-left: 20px;
        }
    }
    .position {
        position: absolute;
        width: 7.5rem;
        top: 2.4rem;
        right: 0.8rem;
        background: white;
        z-index: 9999;
        padding-top: 1.2rem;
        padding-left: 0.6rem;
        z-index: 9999;
        box-shadow: 0rem 0rem 0.2rem 0rem rgba(132, 132, 132, 0.5);
        .item {
            .img-container {
                width: 1rem;
                margin-right: 0.2rem;
                img {
                    display: block;
                }
                &:nth-child(1) {
                    img {
                        width: 0.8rem;
                        height: 0.8rem;
                    }
                }
                &:nth-child(2) {
                    img {
                        width: 0.7rem;
                        height: 0.7rem;
                    }
                }
                &:nth-child(3) {
                    img {
                        width: 0.6rem;
                        height: 0.6rem;
                    }
                }
                &:nth-child(4) {
                    img {
                        height: 0.8rem;
                        width: 0.6rem;
                    }
                }
                &:nth-child(6) {
                    img {
                        margin-left: -0.05rem;
                        width: 0.8rem;
                        height: 0.7rem;
                    }
                }
                &:nth-child(5) {
                    img {
                        height: 0.6rem;
                        width: 0.6rem;
                    }
                }
            }
            display: flex;
            align-items: center;
            margin-bottom: 1.35rem;
            .text {
                color: #07448a;
                line-height: 0.7rem;
                font-size: 0.7rem;
            }
        }
    }
}
.sr {
    flex: 1;
    position: relative;
    overflow-y: auto;
    overflow-x: hidden;
}
.ellipsis {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
